import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/TwitterTools.css';

const TwitterToolsHub = () => {
    const navigate = useNavigate();

    const twitterTools = [
        {
            name: 'Twitter Verification',
            description: 'Analyze Twitter accounts for trustworthiness. Check account age, followers, activity, and get a comprehensive trust score.',
            route: '/twitter-verification',
            icon: '🔍',
            color: '#1da1f2'
        },
        {
            name: 'Account ID Fetcher',
            description: 'Convert Twitter username to numerical ID and vice versa. Get detailed account info including followers and status.',
            route: '/twitter-account-id',
            icon: '🆔',
            color: '#8b5cf6'
        },
        {
            name: 'Twitter Winner Picker',
            description: 'Randomly select winners from tweet retweets. Fair and transparent winner selection for your Twitter promotions.',
            route: '/twitter-winner-picker',
            icon: '🎉',
            color: '#10b981'
        }
    ];

    return (
        <div className="twitter-tools-container">
            <div className="tools-header">
                <div className="badge-featured">Twitter Suite</div>
                <h1>🐦 Twitter Tools</h1>
                <p>Powerful, credit-optimized tools to manage and analyze your Twitter presence</p>
            </div>

            <div className="tools-info-banner-hub">
                <div className="banner-content">
                    <div className="banner-icon">⏱️</div>
                    <div className="banner-text">
                        <h3>Automated Rate Limiting</h3>
                        <p>
                            To protect your API credits, all tools share a global 6-second interval.
                            The system will automatically wait if you make requests too quickly.
                        </p>
                    </div>
                </div>
            </div>

            <div className="tools-grid-hub">
                {twitterTools.map((tool, index) => (
                    <div
                        key={index}
                        className="tool-card-hub"
                        style={{ '--tool-color': tool.color }}
                        onClick={() => navigate(tool.route)}
                    >
                        <div className="tool-card-glow"></div>
                        <div className="tool-icon-hub" style={{
                            background: `linear-gradient(135deg, ${tool.color} 0%, ${tool.color}dd 100%)`,
                            boxShadow: `0 8px 30px ${tool.color}40`
                        }}>
                            {tool.icon}
                        </div>
                        <h3 className="tool-name-hub">{tool.name}</h3>
                        <p className="tool-description-hub">{tool.description}</p>
                        <div className="tool-footer-hub">
                            <span className="credit-cost"></span>
                            <button
                                className="tool-use-btn"
                                style={{
                                    background: `linear-gradient(135deg, ${tool.color} 0%, ${tool.color}dd 100%)`
                                }}
                            >
                                Use Tool →
                            </button>
                        </div>
                    </div>
                ))}
            </div>

            <div className="info-section">
                <h2>ℹ️ Performance & Credits</h2>
                <div className="info-grid">
                    <div className="info-card">
                        <div className="info-icon">💎</div>
                        <h3>Minimized credit usage</h3>
                        <p>
                            Each tool is precision-engineered to make exactly ONE API call per action.
                            We fetch all required data in a single request to save you credits.
                        </p>
                    </div>
                    <div className="info-card">
                        <div className="info-icon">⚡</div>
                        <h3>Real-time Analysis</h3>
                        <p>
                            Data is fetched directly from Twitter's network. No stale information or cached errors.
                            Get the most accurate stats every time.
                        </p>
                    </div>
                    <div className="info-card">
                        <div className="info-icon">🛡️</div>
                        <h3>Fair Competition</h3>
                        <p>
                            The Winner Picker uses a cryptographically secure shuffle to ensure every
                            retweeter has an exactly equal chance to win.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TwitterToolsHub;
